import React, { FC } from 'react'

import { ErrorPageContentProps } from './ErrorPageContent.props'
import './ErrorPageContent.scss'

export const ErrorPageContent: FC<ErrorPageContentProps> = ({ title, description, children }) => {
  return (
    <div className="demo-rm">
      <div className="sbx-row error-page">
        <div className="sbx-col-24">
          {children}
          <h1 className="error-page__title lgt-title">{title}</h1>
          <p className="error-page__description lgt-text">{description}</p>
        </div>
      </div>
    </div>
  )
}

